import { Indicator } from '@repo/utils';
import {
  namespaceFor,
  NewUpdateSurface,
  parseNamespace,
} from './newUpdateIndicators';

export type SeenIndicatorDTO = {
  tiny_account_id: string;
  kit_id: string;
  dot_type: NewUpdateSurface;
  signature: string;
};

export const toSeenIndicatorDTO = ([
  namespace,
  key,
  signature,
]: Indicator): SeenIndicatorDTO => {
  const { surface, tinyAccountId } = parseNamespace(namespace);
  return {
    tiny_account_id: tinyAccountId,
    kit_id: key,
    dot_type: surface,
    signature,
  };
};

export const fromSeenIndicatorDTO = ({
  tiny_account_id,
  kit_id,
  dot_type,
  signature,
}: SeenIndicatorDTO): Indicator => [
  namespaceFor(dot_type, tiny_account_id),
  kit_id,
  signature,
];
